export const SET_GLOBAL_ALERT = 'SET_GLOBAL_ALERT'
export const RESET_GLOBAL_ALERT = 'RESET_GLOBAL_ALERT'